import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Icon, type IconName } from "./icons.js";

type Variant = "primary" | "secondary" | "ghost" | "danger" | "brand" | "accent";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: "sm" | "md";
  icon?: IconName;
  iconRight?: IconName;
  block?: boolean;
  children?: ReactNode;
}

const VARIANT_CLASS: Record<Variant, string> = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  ghost: "btn-ghost",
  danger: "btn-danger",
  brand: "btn-brand",
  accent: "btn-accent",
};

/** Consistent button. Renders the legacy `.btn-*` classes so existing CSS applies. */
export function Button({
  variant = "primary",
  size = "md",
  icon,
  iconRight,
  block,
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = [
    VARIANT_CLASS[variant],
    size === "sm" ? "btn-sm" : "",
    block ? "btn-block" : "",
    !children ? "btn-icon" : "",
    className ?? "",
  ].filter(Boolean).join(" ");

  const iconSize = size === "sm" ? 16 : 18;
  return (
    <button className={classes} {...rest}>
      {icon && <Icon name={icon} size={iconSize} />}
      {children}
      {iconRight && <Icon name={iconRight} size={iconSize} />}
    </button>
  );
}
